/* Progressive enhancement: every article link, category and pagination URL works without JavaScript. */
(() => {
  function initializeJournal(root = document) {
    root.querySelectorAll('[data-journal-section]').forEach((section) => {
      if (section.dataset.journalInitialized) return;
      section.dataset.journalInitialized = 'true';
      section.addEventListener('click', async (event) => {
        const link = event.target.closest('[data-journal-more]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (link.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; }
        event.preventDefault();
        const originalText = link.textContent;
        const nextURL = link.href;
        const status = section.querySelector('[data-journal-status]');
        link.setAttribute('aria-disabled', 'true');
        link.textContent = 'Loading stories…';
        try {
          const response = await fetch(nextURL, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Unable to retrieve the next stories.');
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextSection = Array.from(documentFragment.querySelectorAll('[data-journal-section]')).find((candidate) => candidate.dataset.journalSection === section.dataset.journalSection);
          if (!nextSection) throw new Error('The journal section is missing.');
          const cards = [...nextSection.querySelectorAll('[data-journal-grid] > [data-journal-card]')];
          const grid = section.querySelector('[data-journal-grid]');
          cards.forEach((card) => grid.appendChild(card));
          const replacement = nextSection.querySelector('[data-journal-more]');
          if (replacement) {
            link.href = replacement.href;
            link.textContent = originalText;
            link.removeAttribute('aria-disabled');
          } else {
            section.querySelector('[data-journal-pagination]').remove();
          }
          if (cards.length) {
            const firstNewLink = cards[0].querySelector('h3 a');
            firstNewLink?.focus({ preventScroll: true });
          }
          if (status) status.textContent = `${cards.length} more ${cards.length === 1 ? 'story' : 'stories'} loaded.`;
        } catch (error) {
          link.textContent = originalText;
          link.removeAttribute('aria-disabled');
          if (status) status.textContent = 'Opening the next page of stories.';
          window.location.assign(nextURL);
        }
      });
    });
  }

  function initializeArticle(root = document) {
    root.querySelectorAll('[data-editorial-article]').forEach((article) => {
      if (article.dataset.articleInitialized) return;
      article.dataset.articleInitialized = 'true';
      const body = article.querySelector('[data-article-body]');
      const toc = article.querySelector('[data-article-toc]');
      const tocList = article.querySelector('[data-article-toc-list]');
      const headings = [...body.querySelectorAll('h2, h3')];
      if (headings.length && toc && tocList) {
        tocList.replaceChildren();
        const usedIDs = new Set([...document.querySelectorAll('[id]')].map((element) => element.id));
        headings.forEach((heading, index) => {
          if (!heading.id) {
            const base = heading.textContent.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-]/g, '').trim().replace(/\s+/g, '-') || `story-section-${index + 1}`;
            let id = base;
            let suffix = 2;
            while (usedIDs.has(id)) id = `${base}-${suffix++}`;
            heading.id = id;
            usedIDs.add(id);
          }
          const item = document.createElement('li');
          const anchor = document.createElement('a');
          anchor.href = `#${heading.id}`;
          anchor.textContent = heading.textContent.replace(/\.$/, '');
          item.append(anchor);
          tocList.append(item);
        });
        toc.hidden = false;
      } else if (toc) {
        toc.hidden = true;
      }
      article.querySelector('[data-copy-article-link]')?.addEventListener('click', async () => {
        const status = article.querySelector('[data-copy-status]');
        try {
          await navigator.clipboard.writeText(document.querySelector('link[rel="canonical"]')?.href || window.location.href.split('#')[0]);
          if (status) status.textContent = 'Link copied.';
        } catch (error) {
          if (status) status.textContent = 'Copy this page’s address from your browser to share it.';
        }
      });
    });
  }

  function initialize(root = document) { initializeJournal(root); initializeArticle(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
